import { Befehl } from '../models'

import { findAuftrag, hasFieldContent } from './helpers'

/**
 * Checks if Befehl 26 has empty fields.
 */
export function hasBefehl26EmptyFields(befehl: Befehl): boolean {
  if (!befehl?.auftraege?.length) return false

  const auftrag_26_10 = findAuftrag(befehl, '26.10')

  if (auftrag_26_10) {
    const feld_26_14_km = hasFieldContent(auftrag_26_10, '26.14', 'km')
    const feld_26_15_name = hasFieldContent(
      auftrag_26_10,
      '26.15',
      'zugmeldestelle.name'
    )
    const feld_26_15_art = hasFieldContent(
      auftrag_26_10,
      '26.15',
      'zugmeldestelle.art'
    )

    return !feld_26_14_km || !feld_26_15_name || !feld_26_15_art
  }

  const auftrag_26_12 = findAuftrag(befehl, '26.12')

  if (auftrag_26_12) {
    const feld_26_13_signal = hasFieldContent(auftrag_26_12, '26.13', 'signal')
    return !feld_26_13_signal
  }

  return false
}
